import ModalSlot, { slot } from "src/109323/components/ModalSlot"

const image = "https://assets.swoogo.com/uploads/full/3020122-651f25229c0e3.png"

const slots = [
    {
        label: "I need to strengthen my organisation's ability to respond to cyber incidents",
        href: "https://assets.swoogo.com/uploads/3020264-651f2ea72e353.pdf"
    },
    {
        label: "I need everyone across my organisation to be aware of and adopt cyber security best practice",
        href: "https://assets.swoogo.com/uploads/3020267-651f2ea72c2ca.pdf"
    },
    {
        label: "I need to maximise my organisation's benefitfrom risk assessments.",
        href: "https://assets.swoogo.com/uploads/3020263-651f2ea72aa3c.pdf"
    },
    {
        label: "I need to gain an up-to-date picture of the security status of my suppliers",
        href: "https://assets.swoogo.com/uploads/3020266-651f2ea72f0fa.pdf"
    },
    { 
        label: "I need help identifying my critical security concerns and maximising return on security investment",
        href: "https://assets.swoogo.com/uploads/3020270-651f2ea73b954.pdf"
    },
    {
        label: "I need support with managing compliance across multiple jurisdictions",
        href: "https://assets.swoogo.com/uploads/3020265-651f2ea72e1b1.pdf"
    },
    {
        label: "I need to create a future-proof security strategy",
        href: "https://assets.swoogo.com/uploads/3020268-651f2ea72ff66.pdf"
    },
    {
        label: "I need interim senior-level support that can step in and contribute immediately",
        href: "https://assets.swoogo.com/uploads/3020272-651f2ea74214a.pdf"
    },
    {
        label: "I need to integrate security best practice into the everyday workflows of critical stakeholders",
        href: "https://assets.swoogo.com/uploads/3020269-651f2ea72fdb6.pdf"
    },
    {
        label: "I need to be better armed against cyber threats during periods of instability",
        href: "https://assets.swoogo.com/uploads/3020271-651f2ea73c2ab.pdf"
    },
    {
        label: "I need the board to understand what is required to embed cyber resilience across the organisation",
        href: "https://assets.swoogo.com/uploads/3020273-651f2ea73f323.pdf"
    },
    {
        href: "https://www.isflive.org/s/services-overview",
        label: "for more, please visit ISF Services"
    }
]

export default () => <ModalSlot img={image} links={[
    ...slot(11, {
        height: 6,
        init: 11.4,
        space: 17.8-11.4
    }),
    {
        width: "27%",
        height: "4.8%",
        top: "83.7%",
        left: "34.8%"
    }
]} slots={slots} />